// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1EyW1","footer":"Form_footer__pJrB2"};